module.exports = "query GetCard($id: ID!) {\n  card(id: $id) {\n    ...CardFragment\n  }\n}\n"